import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {UserService} from '../user.service';


@Injectable()
export class AllUsersResolver implements Resolve<any> {
	constructor(
		private userService: UserService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		console.log('AllUsersResolver called    #1');

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			// this.userService.getUsers()
			this.userService.getRecentUsersIndexedDb()
				.then((users: any) => {

					console.log('AllUsersResolver called    #2');
					// console.log(users);

					let allUsersInfo = {
						// users: users.allUsers,
						users: users.allUsers.users,
						params: this.params
					};
					resolve(allUsersInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}




// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-users.resolver.ts